import { useMemo } from "react"

import type {
  DropdownPosition,
  UseDropdownPositionOptions
} from "./useDropdownPosition.types"

export const useDropdownPosition = (
  props: UseDropdownPositionOptions
): DropdownPosition | null => {
  const MENU_WIDTH = 280
  const MENU_HEIGHT = 383
  const OFFSET = 4
  const PADDING = 8
  const {
    triggerRect,
    menuWidth = MENU_WIDTH,
    menuHeight = MENU_HEIGHT,
    offset = OFFSET,
    padding = PADDING
  } = props

  return useMemo(() => {
    if (!triggerRect) return null

    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    const spaceBelow = viewportHeight - triggerRect.bottom - offset - padding
    const spaceAbove = triggerRect.top - offset - padding
    const spaceRight = viewportWidth - triggerRect.left - padding
    const spaceLeft = triggerRect.right - padding

    const fitsBelow = spaceBelow >= menuHeight
    const fitsAbove = spaceAbove >= menuHeight
    const placeAbove = !fitsBelow && (fitsAbove || spaceAbove > spaceBelow)

    const fitsRight = spaceRight >= menuWidth
    const fitsLeft = spaceLeft >= menuWidth
    const placeLeft = !fitsRight && (fitsLeft || spaceLeft > spaceRight)

    let top: number | undefined
    let bottom: number | undefined
    let left: number

    if (placeAbove) {
      bottom = viewportHeight - triggerRect.top + offset
      bottom = Math.max(padding, Math.min(bottom, viewportHeight - padding))
    } else {
      top = triggerRect.bottom + offset
      top = Math.max(
        padding,
        Math.min(top, viewportHeight - menuHeight - padding)
      )
    }

    if (placeLeft) left = triggerRect.right - menuWidth
    else left = triggerRect.left

    left = Math.max(
      padding,
      Math.min(left, viewportWidth - menuWidth - padding)
    )

    return { top, bottom, left, menuWidth, menuHeight }
  }, [triggerRect, menuWidth, menuHeight, offset, padding])
}
